import React from 'react'
import LoaderImage from '../../assets/icons/loading.svg';
import './Loader.css';

export default function FullPageLoader() {
    return (
        <>
            <div className="xcd-loader bg-primary bg-opacity-25">
                <div className="xcd-loader-icon ">
                    <img src={LoaderImage} className="xcd-loader-image" />
                    <h6 className="fw-bold text-primary mt-2">Loading</h6>
                </div>
            </div>
        </>
    )
}